






import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { ChartColors, ChartConstants } from "@/constants/chart";
import { YieldByYearDTO } from "@/api/analyses/types";


@Component({
  name: "YieldBoxPlot",
})
export default class YieldBoxPlot extends Vue {

  @Prop({ type: Array, required: true })
  private yieldByYearList!: YieldByYearDTO[];

  @Prop({ type: String, required: false })
  private title!: string;

  get chartOptions() {
    return {
      chart: { 
        type: 'boxplot' ,
        height: 400,
        style: {
          fontFamily: ChartConstants.FONT_FAMILY
        },
        backgroundColor: ChartColors.BACKGROUND,
      },
      credits: {
        enabled: false,
      },
      title: {
        text: this.title,
        style: ChartConstants.TITLE_STYLE,
        align: 'left'
      },
      legend: { 
        enabled: false 
      },
      xAxis: { 
        categories: this.yieldByYearList.map(it => it.harvestYear), 
      },
      yAxis: {
        title: {
          text: ''
        }
      },
      series: [
        {
          name: this.$t('charts.yield-by-year.yield'),
          data: this.yieldByYearList.map(it => it.asArrayFormatted),
          tooltip: {
            headerFormat: `<em>${this.$t('charts.yield-by-year.yield-in')} {point.key}</em><br/>`
          },
          fillColor: ChartColors.BACKGROUND,
          color:  ChartColors.BLUE_LIGHT,
        }
      ],
      responsive: {
        rules: [{
          condition: {
            maxWidth: 500
          },
          chartOptions: {
            legend: {
              layout: 'horizontal',
              align: 'center',
              verticalAlign: 'bottom'
            }
          }
        }]
      }
    }
  }
}
